import React from "react";
import { Route } from "react-router-dom";

import Page from "@ROM-pages/CompanyAdmin/PriceLists/Show";
import Layout from "@ROM-pages/Layouts/CompanyAdmin";
import Authorize from "@ROM/Auth/components/Authorize";
import { canViewPriceList } from "@ROM/PriceLists/permissions";

class RouteHandler extends Route {
  render() {
    return (
      <Layout>
        <Authorize permission={canViewPriceList}>
          <Page priceListId={this.props.computedMatch.params.priceListid} />
        </Authorize>
      </Layout>
    );
  }
}

export default RouteHandler;
